module.exports = __webpack_public_path__ + "img/gallery_entrance.2ca5ac16.jpg";